export default __webpack_public_path__ + "static/media/stocktakes.5531ad18.svg";